import service from '@/services/superaccess'
const notifications = {
  state: {
    notifications: [],
    news: 0
  },
  getters: {
    getNotifications (state) {
      return state.notifications
    },
    getNews (state) {
      return state.news
    }
  },
  mutations: {
    setNotificationOpen (state, index) {
      state.notifications[index].open_message = !state.notifications[index].open_message
    },
    setNotifications (state, notifications) {
      state.notifications = notifications
    },
    setNews (state, news) {
      state.news = news
    },
    addNew (state) {
      state.news++
    }
  },
  actions: {
    updateNotifications (context, payload) {
      return service.post('/api/notifications', context, { id: context.getters.getUserData.id })
    },
    createNotification (context, payload) {
      return service.post('/api/notification/create', context, { notification: payload }).then((response) => {
        if (response.data.status === 200) {
          context.state.notifications.unshift(response.data.content)
          context.state.news++
        }
      })
    },
    deleteNotification (context, payload) {
      return service.post('/api/notification/delete', context, { id: payload.id })
        .then(response => {
          if (response.data.status === 200) {
            if (context.state.news > 0) {
              context.state.news--
            }
            context.state.notifications.splice(payload.index, 1)
          }
        })
    },
    changeNotificationsState (context, payload) {
      if (payload.length > 0) {
        return service.post('/api/notification/states', context, { ids: payload })
          .then(response => {
            if (response.data.status === 200) {
              context.state.news = 0
            }
          })
      }
    }
  }
}

export default notifications



// WEBPACK FOOTER //
// app/javascript/src/store/notifications.js